export default __webpack_public_path__ + "static/media/market-place.7d444a52.png";